var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rf-empty",attrs:{"role":"status"}},[_c('RefreshIcon',{attrs:{"name":_vm.icon}}),_c('strong',[_vm._v(_vm._s(_vm.title || _vm.$t('lang.NoData')))]),(_vm.description)?_c('p',[_vm._v(_vm._s(_vm.description))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }